import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eMIPaymentOffer'
})
export class EMIPaymentOfferPipe implements PipeTransform {

  readonly MANUAL_PAYMENT_OFFER = [
    { bankCode: '7', key: 'UTIB' },
    { bankCode: 'BOB', key: 'BARB' },
    { bankCode: '20', key: 'CITI' },
    { bankCode: 'DBS', key: 'DBSCC' },
    { bankCode: '21', key: 'ICIC' },
    { bankCode: 'INDUS', key: 'INDB' },
    { bankCode: 'RBL', key: 'RATN' },
    { bankCode: 'SCB', key: 'SCBL' },
    { bankCode: 'KOTAK', key: 'KKBK' },
    { bankCode: 'SBI', key: 'SBIN' },
    { bankCode: 'YES', key: 'YESB' }
  ]

  transform(li: any, eo: any[], sv?: any): any {
    if (!li || !eo?.length) return li;
    const bc = String(li.bankCode || '').toUpperCase().trim(), mo = this.MANUAL_PAYMENT_OFFER, kw = ['cc', 'credit card', 'debit card', 'dc'], sn = (sv?.name || '').toLowerCase(),
      moff = eo.reduce((a, o) => {
        const b = o?.supported_payment_methods?.[6] || [],
          f = b.find((x: any) => (x?.key || '').toUpperCase().trim() === bc),
          m = !f && mo.find(moItem => moItem.bankCode === bc)?.key,
          fm = m && b.find((x: any) => (x?.key || '').toUpperCase().trim() === m);
        return f || fm ? [...a, { ...o, matchedBank: f || fm }] : a;
      }, [] as any[]),
      t = moff.map(o => o?.title).filter((v, i, a) => v && a.indexOf(v) === i && kw.some(k => sn.includes(k) && v.toLowerCase().includes(k))),
      dn = (moff[0]?.matchedBank?.displayName || li?.gtwName || '') + (t.length ? `<span style="font-size:12px;color:green;width:180px;word-wrap:break-word;display:block;word-break:break-word;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;line-height:6px;padding-bottom:4px;">(${t.join(', ')})</span>` : '');
    return { matchedBank: { displayName: dn }, ...li };
  }
}
